import { React, useState, useEffect } from 'react';
import Confetti from 'react-confetti';

// Custom hook to replace useWindowSize from react-use
const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
};

const ConfettiEffect = () => {
  const { width, height } = useWindowSize();
  const [showConfetti, setShowConfetti] = useState(true);
  
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowConfetti(false);
    }, 5000);
    
    return () => clearTimeout(timer);
  }, []);
  
  if (!showConfetti) return null;
  
  return (
    <Confetti
      width={width}
      height={height}
      numberOfPieces={150}
      recycle={false}
      colors={['#ff4b8d', '#ff69b4', '#da70d6', '#ff1493', '#ff85a2', '#ffe6f2']}
      gravity={0.2}
    />
  );
};

export default ConfettiEffect; 